export default __webpack_public_path__ + "static/nargiza-ef7ef3199bb5f110faac52f92d730fba.jpg";